import styled from "styled-components";

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  label {
    color: var(--text-secondary-color);
  }
  .form-element {
    padding: 10px;
    border-radius: 6px 6px;
    border: 1px solid var(--text-secondary-color);
    background: transparent;
    color: var(--text-secondary-color);
    outline: none;
  }
  .form-element:focus {
    border: 1px solid var(--text-color);
  }
  .error {
    color: var(--error-text);
  }
`;

export default Wrapper;
